import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font-config.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font-config.ts\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"]}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font-config.ts\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"openSans\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font-config.ts\",\"import\":\"Playfair_Display\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"playfairDisplay\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font-config.ts\",\"import\":\"Comic_Neue\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"]}],\"variableName\":\"comicNeue\"}");
;
import(/* webpackMode: "eager", webpackExports: ["StorageProvider"] */ "/app/apps/web/src/components/storage-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/apps/web/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/apps/web/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/node_modules/next-themes/dist/index.mjs");
